/* eslint-disable react/self-closing-comp */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import './css/FlightLoader.css';
import { TO, BACK } from '../../../Utils/Constants/GlobalConstants';
import { ReactComponent as Plain } from '../../../images/plain-r.svg';

function FlightLoader() {
  return (
    <div>
      <div className="frt_fligh_depart_wrapper">
        <div className="frt_ticket_content">
          <div className="frt_ticket_dir_col_1">
            <div className="frt_fligh_first_line mb_30">
              <div className="bm_text_22">{TO}</div>
            </div>
            <div className="frt_fligh_second_line">
              <div className="frt_col_1">
                <div className="frt_time_w mb_10">
                  <Plain className="frt_direct_plain_ico" />
                  <div className="frt_flight_time">
                    <Skeleton width="80px" height="30px" />
                  </div>
                </div>
                <div className="gr_text_14 mb_4">
                  <Skeleton width="60px" height="15px" />
                </div>
                <div className="gr_text_14">
                  <Skeleton width="80px" height="15px" />
                </div>
              </div>
              <div className="frt_col_2">
                <div className="gr_text_14 mb_14">
                  <Skeleton width="100px" height="15px" />
                </div>
                <div className="frt_vis_w">
                  <div>
                    <div className="frt_gray_track mb_6"></div>
                    <div
                      className="frt_single_track_airports"
                      style={{ width: '280px' }}
                    >
                      <div className="dbb_text_14">
                        <Skeleton width="35px" height="15px" />
                      </div>
                      <div className="dbb_text_14">
                        <Skeleton width="35px" height="15px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="frt_col_3">
                <div className="frt_time_w mb_10">
                  <Plain className="frt_direct_plain_ico" />
                  <div className="frt_flight_time">
                    <Skeleton width="80px" height="30px" />
                  </div>
                </div>
                <div className="gr_text_14 mb_4">
                  <Skeleton width="60px" height="15px" />
                </div>
                <div className="gr_text_14">
                  <Skeleton width="80px" height="15px" />
                </div>
              </div>
            </div>
          </div>
          <div className="frt_ticket_dir_col_2">
            <div>
              <div className="frt_flight_item_w">
                <div className="bm_text_16 mb_6 frt_loader_flight">
                  <Skeleton width="90px" height="18px" />
                </div>
                <Skeleton width="163px" height="15px" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* flight back */}
      <div className="frt_fligh_return_wrapper">
        <div className="frt_ticket_dir_col_1">
          <div className="frt_fligh_first_line mb_30">
            <div className="bm_text_22">{BACK}</div>
          </div>
          <div className="frt_fligh_second_line">
            <div className="frt_col_1">
              <div className="frt_time_w mb_10">
                <Plain className="frt_direct_plain_ico" />
                <div className="frt_flight_time">
                  <Skeleton width="80px" height="30px" />
                </div>
              </div>
              <div className="gr_text_14 mb_4">
                <Skeleton width="60px" height="15px" />
              </div>
              <div className="gr_text_14">
                <Skeleton width="80px" height="15px" />
              </div>
            </div>
            <div className="frt_col_2">
              <div className="gr_text_14 mb_14">
                <Skeleton width="100px" height="15px" />
              </div>
              <div className="frt_vis_w">
                <div>
                  <div className="frt_gray_track mb_6"></div>
                  <div
                    className="frt_single_track_airports"
                    style={{ width: '280px' }}
                  >
                    <div className="dbb_text_14">
                      <Skeleton width="35px" height="15px" />
                    </div>
                    <div className="dbb_text_14">
                      <Skeleton width="35px" height="15px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="frt_col_3">
              <div className="frt_time_w mb_10">
                <Plain className="frt_direct_plain_ico" />
                <div className="frt_flight_time">
                  <Skeleton width="80px" height="30px" />
                </div>
              </div>
              <div className="gr_text_14 mb_4">
                <Skeleton width="60px" height="15px" />
              </div>
              <div className="gr_text_14">
                <Skeleton width="80px" height="15px" />
              </div>
            </div>
          </div>
        </div>
        <div className="frt_ticket_dir_col_2">
          <div>
            <div className="frt_flight_item_w">
              <div className="bm_text_16 mb_6 frt_loader_flight">
                <Skeleton width="90px" height="18px" />
              </div>
              <Skeleton width="163px" height="15px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FlightLoader;
